import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';

/*
    DEPRECATED — DO NOT USE IN NEW CODE.
    This component will be removed after all usages are migrated.
    Use SelectBoxV2.jsx instead.
*/
const SelectBox = ({ selectValue, selectObject, initialValue, hideLabel }) => {
  
  const [storeValue, setStoreValue] = useState(initialValue);
  const label = selectObject?.label || '';

  useEffect(() => {
    setStoreValue(initialValue);
  }, [initialValue]);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setStoreValue(value);
    selectValue(value);
  };

  return (
    <div>
      <FormControl fullWidth size={selectObject.smallSize ? "small" : "medium"}>
        {!hideLabel && (
          <InputLabel id="select-label">{label}</InputLabel>
        )}
        <Select
          labelId={!hideLabel ? "select-label" : undefined}
          value={storeValue}
          onChange={handleSelectChange}
          label={!hideLabel ? label : undefined}
        >
          {selectObject.menuItems.map((item, index) => (
            <MenuItem key={index} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};


export default SelectBox;